import React from "react";
import Footer from "./Footer";
import "./Manpower.css";

const Manpower = () => {
  return (
    <>
      <section className="manpower-page">
        <div className="manpower-container">
         <h1>COMING SOON</h1>

          
        </div>
      </section>

      {/* ✅ Footer added */}
      <Footer />
    </>
  );
};

export default Manpower;
